<template>
  <div class="flex items-center">
    <!-- <icon name="search" class="text-lg" /> -->
    <input class="relative px-6 py-3 w-full rounded shadow focus:shadow-outline" autocomplete="off" type="text" name="search" placeholder="Buscar…" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
    <button class="ml-3 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button" @click="$emit('reset')">Limpiar</button>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,   
  },
  props: {
    modelValue: String,
  },
  emits: ['update:modelValue', 'reset'],
}
</script>
